module.exports = __webpack_public_path__ + "5fdd15ec40d3590e74ecae501f3b9ec3.png";